import { ReactElement, useContext } from "react";

import {
  AuthTransaction,
  StatusEnum,
} from "pages/register/types/authTransaction";

import PageLoading from "global-components/pageLoading/PageLoading";
import ErrorPage from "global-components/errorPage/ErrorPage";
import MfaEnrollment from "../mfaEnrollment/MfaEnrollment";
import CompleteRegistrationContainer from "pages/register/components/completeRegistrationContainer/CompleteRegistrationContainer";
import RegistrationForms from "../registrationForms/RegistrationForms";
import ExpiredTransactionModal from "global-components/mfa/components/expiredTransactionModal/ExpiredTransactionModal";

import AuthTransactionContext from "pages/register/contexts/AuthTransactionContext";

import { getRegistrationData } from "pages/register/util/registrationDataManager";

const RegisterContainer = (): ReactElement => {
  const {
    transaction,
    setTransaction,
    isFetchingTransaction,
    isTransactionExpired,
    // Use this as the source of truth for all factor data
    factorData,
  } = useContext(AuthTransactionContext);

  const hasActiveFactor = factorData.factorOrder.some((factor) => {
    return factorData.factorMap[factor]?.flags.isActive;
  });
  const { sessionToken } = getRegistrationData();

  const getViewToRender = (transaction: AuthTransaction | undefined) => {
    if (isFetchingTransaction) {
      return <PageLoading />;
    } else if (!!sessionToken) {
      return <CompleteRegistrationContainer />;
    } else if (!transaction) {
      return <RegistrationForms />;
    } else if (
      transaction.status === StatusEnum.MfaEnroll ||
      transaction.status === StatusEnum.MfaEnrollActivate
    ) {
      return (
        <MfaEnrollment
          hasActiveFactor={hasActiveFactor}
          transaction={transaction}
          setTransaction={setTransaction}
          factorData={factorData}
        />
      );
    } else {
      // TODO: In this scenario, something unexpected occurred
      // Delete the stateToken and show an alert to tell the user to start over

      return <ErrorPage />;
    }
  };

  return (
    <>
      {getViewToRender(transaction)}

      {isTransactionExpired && <ExpiredTransactionModal />}
    </>
  );
};

export default RegisterContainer;
